import { Controller } from "@hotwired/stimulus"
import * as SimpleSwitch from "a-simple-switch"

export default class extends Controller {
  static values = { url: String, kind: String }
  static targets = ["field"]

  async toggle(event) {
    const checkbox = event.target
    const active = checkbox.checked

    // For BREAK: if activating, deactivate all other switches visually first
    if (active && this.kindValue === 'BREAK') {
      this.deactivateOtherSwitches()
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          tenant_lease_break: { active }
        })
      })

      if (response.ok) {
        // Process Turbo Stream response to update tenant table cells
        const html = await response.text()
        if (html) {
          Turbo.renderStreamMessage(html)
        }
      } else {
        // Revert checkbox state on error
        SimpleSwitch.toggle(checkbox, !active)
        console.error('Failed to update lease break')
      }
    } catch (error) {
      // Revert checkbox state on error
      SimpleSwitch.toggle(checkbox, !active)
      console.error('Error updating lease break:', error)
    }
  }

  deactivateOtherSwitches() {
    // Find the table body containing all BREAK rows
    const tbody = document.getElementById('lease_breaks_tbody_break')
    if (!tbody) return

    // Find all other switch checkboxes and uncheck them
    const allSwitches = tbody.querySelectorAll('input[name="active"]')
    allSwitches.forEach(sw => {
      if (sw !== this.fieldTarget && sw.checked) {
        SimpleSwitch.toggle(sw, false)
      }
    })
  }
}
